import React from 'react';
import PropTypes from 'prop-types';
import './articleTiles.css';

const ArticleTiles = props => {
  return (
    <div className="article-tiles">
      <div className="main">{props.articles[0] ? props.articles[0] : null}</div>
      <div className="aside">
        <div className="aside-1">
          {props.articles[1] ? props.articles[1] : null}
        </div>
        <div className="aside-2">
          {props.articles[2] ? props.articles[2] : null}
        </div>
      </div>
    </div>
  );
};

ArticleTiles.propTypes = {
  articles: PropTypes.array.isRequired,
};

export default ArticleTiles;



// WEBPACK FOOTER //
// ./src/ui/src/component/articleTiles/articleTiles.js